
import { Box, SegmentedControl } from '@primer/react';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IMenuModel } from '../../models/response/account/user-info';
import { actions } from '../../state/actions/actionsWrapper';
import { RootState } from '../../state/reducers';
import styles from "./MenuGroup.module.css"
const IsHaveChidrenMatchPath = (rootMenu: IMenuModel, path: string): boolean => {
    // debugger
    if (rootMenu.items.length > 0) {
        const menu = rootMenu.items.find(x => x.path === path || IsHaveChidrenMatchPath(x, path));
        return menu !== undefined;
    } else {
        return rootMenu.path === path;
    }
    return false;
}
const MenuGroup = () => {
    const { user_info } = useSelector((x: RootState) => x.auth)
    const { menu_group_id, language } = useSelector((x: RootState) => x.common)
    const dispatch = useDispatch();
    // console.log({
    //     user_info
    // });

    useEffect(() => {
        const pathname = window.location.pathname.slice(1);
        if (menu_group_id === undefined) {
            let result: number = 0;
            user_info?.menus.forEach(rootMenu => {
                if (result === 0) {
                    const check = IsHaveChidrenMatchPath(rootMenu, pathname);
                    if (check) {
                        result = rootMenu.id;
                    }
                }
            })
            dispatch(actions.common.changeMenuGroup(result))

            // if (menu) {
            //     if (menu.menu_parent_id === 0) {
            //         dispatch(actions.common.changeMenuGroup(menu.menu_parent_id))
            //     } else {
            //         const menuParent = user_info?.menus.find(x => x.id === menu.menu_parent_id)
            //         if (menuParent && menuParent.menu_parent_id === 0) {
            //             dispatch(actions.common.changeMenuGroup(menuParent.id))
            //         }
            //     }
            // }
        }
    }, [menu_group_id])

    const meuGroupSelectedId = useMemo(() => {
        if (menu_group_id === 0) return 1207
        return menu_group_id;
    }, [menu_group_id])


    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }} >
                {user_info &&
                    <Box className={styles.container}>
                        <SegmentedControl
                            // size='small'
                            onChange={(e) => {
                                dispatch(actions.common.changeMenuGroup(user_info.menus[e].id))
                            }}
                            sx={{
                                // backgroundColor: "red"
                            }}

                        >
                            {user_info.menus.map((menu, index) => {
                                const Icon = () => {
                                    return <i className={`${menu.icon}`}></i>
                                }
                                return (
                                    <SegmentedControl.Button key={index}
                                        selected={menu.id === meuGroupSelectedId}
                                        leadingIcon={Icon}
                                        sx={{
                                            color: "#182C62",
                                            // backgroundColor: menu.id === meuGroupSelectedId ? "red" : undefined
                                        }}
                                        className={(menu.id === meuGroupSelectedId) ? styles.selected : ""}

                                    >
                                        {language === "en" ? menu.name_en : menu.name}
                                    </SegmentedControl.Button>
                                )
                            })}
                        </SegmentedControl>
                    </Box>
                }


            </Box>
        </>

    );
};

export default MenuGroup;